<template>
  <section id="video">
    <v-container class="text-center">
      <div
        data-aos-duration="1500"
        data-aos="fade-down"
        class="
          error--text
          text--darken-3
          font-weight-bold
          mb-8
          text-h4 text-sm-h3
        "
      >
        الفيديو الاعلاني
      </div>
      <div class="video">
        <video
          controls
          :width="
            $vuetify.breakpoint.mdAndUp
              ? 800
              : $vuetify.breakpoint.smOnly
              ? 500
              : 300
          "
        >
          <source src="@/assets/imgs/CVideo.mp4" type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>